import React from 'react';
import FooterTwo from '../Footer/FooterTwo';
import HeaderFour from '../Header/HeaderFour';

import Logo from '../../assets/img/logo/sanasa-logo-white.png';

// The usual page frame: header, the page, footer.
const PageShell = ({ children }) => (
  <>
    <HeaderFour />
    {children}
    <FooterTwo
      footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
      footerLogo={Logo}
      btnClass="it-btn-white sky-bg"
      copyrightTextClass="it-copyright-text inner-style text-center"
    />
  </>
);

export default PageShell;
